module.exports = __webpack_public_path__ + "img/image_chip.9b91b9a0.png";